import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getTags = async () => {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/tags`
    );
    return response.data;
};